// Generated by ts-to-zod
import { z } from 'zod';
import { inboxSchema } from '../../inboxes/models/inbox.schema';
import { automationLevelSchema } from '../models/automationLevel.schema';

export const queueListQuerySchema = z.object({
  pageSize: z.number().optional(),
  page: z.number().optional(),
  ordering: z.array(z.string()).optional(),
  id: z.array(z.number()).optional(),
  workspace: z.array(z.number()).optional(),
  deleting: z.boolean().optional(),
  name: z.string().optional(),
  dedicatedEngine: z.array(z.number()).optional(),
  genericEngine: z.array(z.number()).optional(),
  engine: z.array(z.number()).optional(),
  enginesFilterMode: z.union([z.literal('OR'), z.literal('AND')]).optional(),
  hooks: z.array(z.number()).optional(),
  automationLevel: z.array(automationLevelSchema).optional(),
});

export const queueListSideloadSchema = z.object({
  inboxes: z.array(inboxSchema),
});
